import { apiSlice } from "app/api/apiSlice"

export const feastDaysApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['FeastDay'],
    endpoints: builder => ({
        getFeastDays: builder.query({
            query: ({year, countryCode}) => {
                return {
                    url: 'hr/utility/holidays',
                    params: { 
                        year: year,
                        country: countryCode
                     }
                }
            },
            keepUnusedDataFor: 5,
            providesTags: ['FeastDay']
        }),

    })

})

export const {
    useGetFeastDaysQuery
} = feastDaysApiSlice